














import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import userx from '@/store/modules/userx';
import { OAuthSigninMethod, User } from '@/store/firestore';
import { EditState } from '@/store/models.def';

declare const CrazyGames: any;

@Component({
  components: {},
})
export default class CrazyGamesLinkButton extends Vue {
  @Prop() public user!: User;
  public state: EditState = 'active';
  public get hasProvider() {
    return userx.userDoc.crazyGames;
  }
  public get providerName() {
    return 'Crazy Games';
  }
  public get variant() {
    return `brand-crazyGames`;
  }
  public get title() {
    return this.hasProvider
      ? `Unlink with ${this.providerName}`
      : `Link with ${this.providerName}`;
  }
  public get label() {
    const labels = this.hasProvider
      ? {
          active: `Unlink with ${this.providerName}`,
          sending: `Unlinking...`,
          done: `Unlinked with ${this.providerName}`,
        }
      : {
          active: `Link with ${this.providerName}`,
          sending: `Linking...`,
          done: `Linked with ${this.providerName}`,
        };
    return labels[this.state];
  }

  public async linkUnlink() {
    if (this.hasProvider) {
      return this.unlink();
    }
    return this.link();
  }

  public async getToken() {
    try {
      const token = (await CrazyGames.SDK.user.getUserToken()) as string;
      return token;
    } catch (error) {
      return this.promptCrazyGamesSignIn();
    }
  }

  public async promptCrazyGamesSignIn() {
    try {
      const user = await CrazyGames.SDK.user.showAuthPrompt();
      const token = (await CrazyGames.SDK.user.getUserToken()) as string;
      return token;
    } catch (error) {
      return '';
    }
  }

  public async link() {
    this.state = 'sending';
    try {
      const token = await this.getToken();
      if (token) {
        const result = await userx.linkUserWithCrazyGames(token);
      }
    } catch (error) {
      this.$root.$emit('error', error);
    }
    this.state = 'active';
  }
  public async unlink() {
    const value = await this.$bvModal.msgBoxConfirm('Are you sure?', {
      title: `Unlink with ${this.providerName}`,
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'danger',
      cancelVariant: 'link btn-link-warning',
      modalClass: 'funny-modal',
      okTitle: 'Confirm',
      cancelTitle: 'Cancel',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    });
    if (!value) {
      return;
    }
    this.state = 'sending';
    const result = await userx.unlinkUserWithCrazyGames();
    this.state = 'active';
  }
}
